<template>
    <section class="areas-section with-icon with-top-effect">
        <div class="container">
            <div class="row">
                <div class="col-md-5 col-sm-5 text-center">
                    <img :src="articleImageUrl" class="img-responsive" />
                </div>
                <div class="col-md-7 col-sm-7 text-left">
                    <div class="clearfix" style="padding-right: 3px;">
                        <div class="above-title">{{ article.aboveTitle }}</div>
                        <h4>{{ article.title }}</h4>
                    </div>
                    <div v-html="contentPreview"></div>
                </div>
                <div class="col-md-12 col-sm-12">
                    <div v-html="contentRemainder"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CommonArticle',
    props: {
        article: Object // 确保传入的是一个对象  
    },
    computed: {
        articleImageUrl() {
            return process.env.VUE_APP_API_BASE_URL + (this.article.image || '');
        },
        content() {
            return this.article.content || '';
        },
        contentPreview() {
            // 找到第二个</p>标签的索引  
            const secondClosingPTagIndex = this.findSecondClosingPTagIndex(this.content);

            // 如果没有找到第二个</p>，或者内容太短，则返回整个内容或空字符串（根据你的需求）  
            if (secondClosingPTagIndex === -1 || this.content.length <= secondClosingPTagIndex) {
                return this.content; // 或者返回一个空字符串或默认文本  
            }

            // 截取到第二个</p>之前的所有内容  
            return this.content.substring(0, secondClosingPTagIndex);
        },
        contentRemainder() {
            // 找到第二个</p>标签的索引  
            const secondParagraphEndIndex = this.findSecondClosingPTagIndex(this.content);

            // 如果没有找到第二个</p>，则返回原始内容或空字符串（根据你的需求）  
            if (secondParagraphEndIndex === -1) {
                return ''; // 或者 return this.content;  
            }

            // 截取从第二个</p>标签之后到内容结束的所有内容  
            // 注意：这里我们实际上是在截取第二个</p>之后的内容，如果你想要包括第一个</p>和第二个</p>之间的内容，  
            // 你需要稍微调整索引位置，但考虑到你的需求是“内容其余部分”，这里应该是正确的  
            return this.content.substring(secondParagraphEndIndex + 4); // +4 是因为我们要跳过</p>这四个字符  
        }
    },
    methods: {
        findSecondClosingPTagIndex(html) {
            let count = 0;
            let index = -1;

            for (let i = 0; i < html.length; i++) {
                if (html.substring(i, i + 4) === '</p>') {
                    count++;
                    if (count === 2) {
                        index = i;
                        break;
                    }
                }
            }

            return index;
        },
        // 辅助方法：找到HTML字符串中第二个</p>标签的索引  
        findSecondClosingPTagIndex(html) {
            let count = 0;
            let index = -1;

            for (let i = 0; i < html.length; i++) {
                if (html.substring(i, i + 4) === '</p>') {
                    count++;
                    if (count === 2) {
                        index = i;
                        break;
                    }
                }
            }

            return index;
        }
    }
}  
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/CommonArticle.vue